import { useEffect, useRef } from "react";

export default function LandingPage({ onEnter, isExiting }) {
  const enteredRef = useRef(false);

  const enter = () => {
    if (enteredRef.current) return;
    enteredRef.current = true;
    onEnter();
  };

  useEffect(() => {
    const timer = setTimeout(enter, 3000);
    const onWheel = (e) => { if (e.deltaY > 20) enter(); };
    const onKey   = (e) => { if (e.key === "Enter" || e.key === "ArrowDown") enter(); };
    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKey);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      position:"fixed", inset:0, zIndex:9999,
      background:"radial-gradient(ellipse at 50% 60%, #161614 0%, #0A0A08 100%)",
      display:"flex", flexDirection:"column", justifyContent:"space-between",
      padding:"clamp(28px,4vw,52px) clamp(24px,5vw,68px)",
      opacity: isExiting ? 0 : 1,
      transition:"opacity .7s cubic-bezier(.4,0,.6,1)",
      overflow:"hidden",
    }}>
      {/* 노이즈 레이어 */}
      <div style={{
        position:"absolute", inset:0, pointerEvents:"none", zIndex:0, opacity:.025,
        backgroundImage:"repeating-linear-gradient(0deg,transparent,transparent 1px,rgba(255,255,255,1) 1px,rgba(255,255,255,1) 2px),repeating-linear-gradient(90deg,transparent,transparent 1px,rgba(255,255,255,1) 1px,rgba(255,255,255,1) 2px)",
        backgroundSize:"3px 3px",
      }} />

      {/* TOP BAR */}
      <div style={{ position:"relative", zIndex:1, display:"flex", justifyContent:"space-between", alignItems:"center", animation:"landDrop 1s cubic-bezier(.16,1,.3,1) .1s both" }}>
        <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"#252523", textTransform:"uppercase" }}>Underlooked</span>
        <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"#252523", textTransform:"uppercase" }}>26 S/S Collection</span>
      </div>

      {/* CENTER */}
      <div style={{ position:"relative", zIndex:1, textAlign:"center" }}>
        <p style={{
          fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:"clamp(8px,.9vw,11px)",
          letterSpacing:"clamp(4px,.7vw,9px)", color:"#1E1E1C",
          textTransform:"uppercase", marginBottom:"clamp(24px,3.5vw,44px)",
          animation:"landDrop 1s cubic-bezier(.16,1,.3,1) .25s both",
        }}>
          Seoul &mdash; Performance Streetwear &mdash; 2026
        </p>
        <div style={{ animation:"landRise 1.4s cubic-bezier(.16,1,.3,1) .15s both" }}>
          <h1 style={{
            fontFamily:"'DM Serif Display',serif",
            fontSize:"clamp(48px,9vw,130px)",
            fontWeight:400, lineHeight:.88, color:"#F8F8F6",
            letterSpacing:"-.02em", marginBottom:"clamp(18px,2.5vw,32px)",
          }}>
            <span style={{ display:"block" }}>UNDER</span>
            <span style={{ display:"block", paddingLeft:"clamp(16px,2.5vw,40px)" }}>LOOKED</span>
          </h1>
        </div>
        <p style={{
          fontFamily:"'Presentation5',sans-serif", fontSize:"clamp(12px,1.3vw,16px)",
          fontWeight:300, color:"rgba(242,241,237,.2)", letterSpacing:3, fontStyle:"italic",
          animation:"fadeIn 1.2s ease .9s both",
        }}>
          움직임을 위해 설계된 옷.
        </p>
      </div>

      {/* BOTTOM */}
      <div style={{ position:"relative", zIndex:1, display:"flex", justifyContent:"space-between", alignItems:"flex-end", animation:"fadeIn 1s ease .8s both" }}>
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:8, paddingBottom:2 }}>
          <div style={{ width:1, height:44, background:"linear-gradient(to bottom, transparent, rgba(60,60,58,.6))", animation:"scrollPulse 2.4s ease-in-out 1.5s infinite" }} />
          <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:7, letterSpacing:4, color:"#1A1A18", textTransform:"uppercase" }}>Scroll</span>
        </div>
        <button className="land-enter-btn" onClick={enter}>
          Enter Collection <span style={{ fontSize:14 }}>→</span>
        </button>
      </div>
    </div>
  );
}
